// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBItXtjyZd3seO3i0CjWh1xUvSjbTQiyFE",
  authDomain: "hmbprequal.firebaseapp.com",
  projectId: "hmbprequal",
  storageBucket: "hmbprequal.firebasestorage.app",
  messagingSenderId: "808189074995",
  appId: "1:808189074995:web:cc507189cc3fc01be14d46",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
